import { SpinnerService } from './../shared/spinner/spinner.service';
import { Component, Input, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { AuthenticationService } from '../security/authentication.service';
import { Router, ActivatedRoute, Params }   from '@angular/router';
import { environment } from '../../environments/environment';
import { CancellationService } from './cancellation.service';
import { Order } from '../entity/order';
import { ThirdParty } from '../entity/third-party';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import {IMyOptions, IMyDateModel} from 'ngx-mydatepicker';
import { CommentsComponent } from '../comments/comments.component';



@Component({
  selector: 'cancellation-list',
  templateUrl: './cancellation-list.component.html'
})

export class CancellationListComponent {
  private filters;
  private statuses;
  private showFilters;
  private allOrders;
  private orders: Order[];
  private allSamples: any[];
  private samples: {};
  private sampleOrders: {};
  private allSampleResults: any[];
  public counts: {};  
  public search: string;
  public lastComment: {};
  public allComments;
  public loadingMore: boolean;
  private currentPage: number;
  public loading: boolean;
  public modalRef: BsModalRef;

  constructor(private router: Router, private route: ActivatedRoute, private authenticationService: AuthenticationService, private cancellationService: CancellationService,
    private spinnerService: SpinnerService, private modalService: BsModalService) {
    this.orders = [];
    this.allOrders = [];
    this.allSamples = [];
    this.allSampleResults = [];
    this.sampleOrders = {};
    this.search = '';
    this.lastComment = {};
    this.allComments = new Array();
    this.loadingMore = false;
    this.loading = false;
    this.filters = {dateStart:null, dateEnd:null, request:null, sample:null, du:null, product:null, selectedStatus:""};
    /*this.statuses = [
        {code : "", label : ""},
        {code : "VALIDE", label : "Validées"},
        {code : "EN ATTENTE", label : "En attente"},
        {code : "ANNULE", label : "Rejetées"}];*/
    this.currentPage = 1;
    this.showFilters =  true;
  }

    private datePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        dayLabels: {su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam'},
        monthLabels: { 1: 'Janvier', 2: 'Fevrier', 3: 'Mars', 4: 'Avril', 5: 'Mai', 6: 'Juin', 7: 'Juillet', 8: 'Aout', 9: 'Septembre', 10: 'Octobre', 11: 'Novembre', 12: 'Decembre' },
        showTodayBtn: false,
        sunHighlight: false,
        alignSelectorRight: false
    };

  ngOnInit(): void {
    this.allOrders = this.route.snapshot.data['orders']['orders'];
    this.allSamples = this.route.snapshot.data['orders']['samples'];
    this.allSampleResults = this.route.snapshot.data['orders']['sampleResults'];
    this.counts = this.route.snapshot.data['orders']['counts'];
    this.lastComment = this.route.snapshot.data['orders']['lastComment'];
    this.allComments = this.route.snapshot.data['orders']['allComments'];
    this.prepareSampleAndResults();
  }


    /**
     * Link samples with orders and results with samples
     */
  private prepareSampleAndResults() {
    this.orders = this.allOrders;
    this.samples = {};
    this.sampleOrders = {};
    for (let order of this.orders) {
      let orderId = order['id'];
      this.samples[orderId] = {};
      for (let index in order['infos']['results']) {
          if (!order['infos']['results'].hasOwnProperty(index)) {
              continue;
          }
          let result = order['infos']['results'][index];
          let resultId = result['id'];
          let sampleId = this.allSampleResults[resultId];
          if (!this.samples[orderId][sampleId]) {
              this.samples[orderId][sampleId] = this.allSamples[sampleId];
              for (let tp of this.allSamples[sampleId].thirdParties) {
                if (tp.type === 'COLLECTEUR') {
                  this.samples[orderId][sampleId].collect = tp.thirdParty;
                  break;
                }
              }
              this.samples[orderId][sampleId].results = [];
          }
          this.samples[orderId][sampleId].results.push(result);
      }
    }
    for (let orderId in this.samples) {
      if (!this.samples.hasOwnProperty(orderId)) {
        continue;
      }
      this.sampleOrders[orderId] = Object.keys(this.samples[orderId]);
    }

  }

  public cancelOrder(order){
    this.openConfirmDialog(order);
   // this.spinnerService.start('Merci de patienter');
    // prepare reject order data post request
    let data = new Object();
    data['orderNumber'] = order.number;
    
    this.modalRef.content.onClose.subscribe(result => {

      if(result) {
              // call api
        this.cancellationService.postCancelOrder(data).then(
          function(response: any){
              this. filter();
          }.bind(this),
          function(){
            this.spinnerService.stop();
          }.bind(this)
        );
      }
  })
  
  }

  filter(): void {
      this.spinnerService.start('Merci de patienter');
      this.loading = true;
      // get orders
      let criteria = {
          start_date: this.filters.dateStart,
          end_date: this.filters.dateEnd,
          request: this.filters.request,
          sample: this.filters.sample,
          du: this.filters.du,
          selectedStatus: this.filters.selectedStatus,
          page: this.currentPage
      };
      this.cancellationService.getCancellationOrders(criteria).then(
          function(response: any){
              this.allOrders = response.orders;
              this.allSamples = response.samples;
              this.allSampleResults = response.sampleResults;
              this.counts = response.counts;
              this.lastComment =  response.lastComment;
              this.allComments = response.allComments;

              this.prepareSampleAndResults();
              this.spinnerService.stop();
              this.loading = false;
          }.bind(this),
          function(){
              this.spinnerService.stop();
          }.bind(this)
      );
  }

    clearFilters(): void {
        this.spinnerService.start('Merci de patienter');
        this.loading = true;
        this.filters = {dateStart:null, dateEnd:null, request:null, sample:null, du:null, product:null, selectedStatus:""};

        // get orders
        let criteria = {
            start_date: this.filters.dateStart,
            end_date: this.filters.dateEnd,
            request: this.filters.request,
            sample: this.filters.sample,
            du: this.filters.du,
            selectedStatus: this.filters.selectedStatus,
            page: this.currentPage
        };
        this.cancellationService.getCancellationOrders(criteria).then(
            function(response: any){
                this.allOrders = response.orders;
                this.allSamples = response.samples;
                this.allSampleResults = response.sampleResults;
                this.counts = response.counts;
                this.lastComment =  response.lastComment;
                this.allComments = response.allComments;

                this.prepareSampleAndResults();
                this.spinnerService.stop();
                this.loading = false;
            }.bind(this),
            function(){
                this.spinnerService.stop();
            }.bind(this)
        );
    }

    openConfirmDialog(order) {  
    
      this.modalRef = this.modalService.show(CommentsComponent,
        { class: 'modal-lg modal-dialog-centered',
        ignoreBackdropClick: true, 
        keyboard: false
      });
  
      this.modalRef.content.order = order;
  
      this.modalRef.content.onClose.subscribe(result => {
  
          if(result) {
              /*let orderComments  = this.cancellationService.getOrderComments(order.number);
              console.log(orderComments);
              this.allComments[order.number] = [];
              this.allComments[order.number].push(orderComments);*/
              this.filter();
          }
      });
  }


}


// WEBPACK FOOTER //
// ./src/app/cancellation/cancellation-list.component.ts